// Blink dash demo ability.

import { registerBehavior } from './registry';
import type { World } from '../world';
import { G } from '../state';
import { S, TILE } from '../constants';
import { Get, GetRoom } from '../mapgen';
import { TileData } from '../tiles';
import { SND_Pos } from '../../audio/index';

const tr = Math.trunc;

let lastBlinkMs = 0;

export function resetDashBlinkCooldown(): void {
  lastBlinkMs = 0;
}

function blinkDistance(): number {
  return S(80);
}

function canBlink(_world: World): boolean {
  if (G.explored < 100) return false;
  if (G.magic_circuit > 0) return false;
  return performance.now() - lastBlinkMs >= 3000;
}

function tryBlink(world: World): boolean {
  if (!canBlink(world)) return false;
  const dirs = [
    { dx: 0, dy: -1 },
    { dx: 0, dy: 1 },
    { dx: -1, dy: 0 },
    { dx: 1, dy: 0 },
  ];
  let dir = dirs[G.player_dir] ?? dirs[0];
  if (G.player_dir === 2) dir = { dx: 1, dy: 0 };
  if (G.player_dir === 3) dir = { dx: -1, dy: 0 };

  const dist = blinkDistance();
  const nx = G.player_x + dir.dx * dist;
  const ny = G.player_y + dir.dy * dist;
  const tile = Get(tr((nx + S(8)) / TILE), tr((ny + S(12)) / TILE));
  if (TileData[tile]?.Is_Solid) return false;

  G.player_x = nx;
  G.player_y = ny;
  lastBlinkMs = performance.now();
  SND_Pos('dat/a/crystal.wav', 100, 0);
  return true;
}

registerBehavior({
  id: 'dash-blink',
  onTick() {
    // Triggered via ability runtime on SP press edge.
  },
});

export function tryDashBlinkAbility(world: World): boolean {
  return tryBlink(world);
}
